import * as ACTION from './constants';
const initialState = {
    welcomeVideo: null,
};
export default function reducers(state = initialState, action) {
    switch(action.type) {
        case ACTION.UPDATE_WELCOME_VIDEO:
            return {
                ...state,
                welcomeVideo: {
                    ...action.item
                }

            };
        default:
            return state;
    }
}